import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../../styles/shared";
import "../../molecules/user-auth";
import "../../atoms/logo";
import { DEFAULT_AUTH_PROVIDER_KINDS } from "shared";
import { pushState } from "../../util/route-util";
import { ROUTES } from "../../config";
import { property } from "lit/decorators/property.js";
import { when } from "lit/directives/when.js";
import "../../molecules/landing/landing-feature-carousel";
import { AI_FEATURES, CORE_FEATURES, FACILITATE_FEATURES } from "../../data/all-features";

@customElement("bs-landing-get-started-page")
class BsLandingGetStartedPage extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: flex;
					min-height: var(--app-height);
					background: var(--get-started-bg, var(--background));
				}

				#container {
					display: flex;
					width: 100%;
				}

				.grower {
					min-height: var(--space-l);
					flex-grow: 1;
				}

				#logo {
					position: fixed;
					left: var(--space-l);
					top: var(--space-l);
					z-index: 12345678;
				}

				#left,
				#right {
					width: 100%;
				}

				#left {
					display: flex;
					flex-direction: column;
					position: relative;
				}

				#right {
					background-color: rgba(255, 255, 255, 0.7);
					background-image: var(
						--get-started-bg,
						radial-gradient(at 56% 57%, rgb(255, 255, 255) 0px, transparent 50%),
						radial-gradient(at 78% 76%, rgba(232, 243, 253, 0.79) 0px, transparent 50%),
						radial-gradient(at 81% 29%, rgba(0, 255, 247, 0.45) 0px, transparent 50%),
						radial-gradient(at 28% 22%, rgba(253, 112, 255, 0.38) 0px, transparent 50%),
						radial-gradient(at 21% 84%, rgba(255, 214, 253, 0.46) 0px, transparent 50%),
						radial-gradient(at 71% 1%, rgba(0, 191, 255, 0.45) 0px, transparent 50%)
					);
					padding: var(--space-m);
					display: flex;
					align-items: center;
					justify-content: center;
				}

				#img {
					width: 400px;
					object-fit: contain;
				}

				#user-auth {
					height: auto;
					margin: 0 auto;
					max-width: 350px;
					width: 100%;
					--dialog-wrapper-content-overflow-y: visible;
				}

				@media (max-width: 900px) {
					#right {
						display: none;
					}
				}
			`
		];
	}

	@property({ type: Boolean, reflect: true, attribute: "hide-logo" }) hideLogo = false;
	@property({ type: String }) headline = "Get Started";
	@property({ type: String }) text = "Choose how you want to continue";
	@property({ type: String }) illustration?: string;

	cancel() {}

	done() {
		pushState(ROUTES.home, { replace: true });
	}

	renderIllustration() {
		if (this.illustration != null) {
			return html` <img id="img" alt="Illustration" src="${this.illustration}" loading="lazy" /> `;
		}

		import("../../molecules/landing/landing-feature-carousel");
		return html`
			<bs-landing-feature-carousel
				.items="${[...CORE_FEATURES, ...AI_FEATURES, ...FACILITATE_FEATURES]}"
			></bs-landing-feature-carousel>
		`;
	}

	render() {
		return html`
			${when(!this.hideLogo, () => html` <bs-logo id="logo"></bs-logo> `)}
			<div id="container">
				<div id="left">
					<div class="grower"></div>
					<bs-user-auth
						id="user-auth"
						@cancel="${this.cancel}"
						@done="${this.done}"
						headline="${this.headline}"
						text="${this.text}"
						progress-text="Signing up..."
						.kinds="${DEFAULT_AUTH_PROVIDER_KINDS}"
					></bs-user-auth>
					<div class="grower"></div>
				</div>
				<div id="right">${this.renderIllustration()}</div>
			</div>
		`;
	}
}
